// extracted by mini-css-extract-plugin
export default {"minorHeader":"MinorHeader_minorHeader__QYDUt","minorDescr":"MinorHeader_minorDescr__AlPSu"};